import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { filter } from 'rxjs/operators';
import { State } from '../../../store/reducers';
import * as roomActions from '../../../store/actions/rooms.action';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-room-detail',
  templateUrl: './room-detail.component.html',
  styleUrls: ['./room-detail.component.css']
})
export class RoomDetailComponent implements OnInit, OnDestroy {
  room;
  roomSubscription: Subscription;
  constructor(private route: ActivatedRoute, private store: Store<State>) {}

  ngOnInit() {
    const roomId = this.route.snapshot.paramMap.get('id');
    this.store.dispatch(new roomActions.SelectRoom(roomId));
    this.roomSubscription = this.store
      .select(state => state.rooms.selectedRoom)
      .subscribe(room => (this.room = room));
  }

  ngOnDestroy() {
    this.roomSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/room-detail/room-detail.component.ts